import {
    /** FETCH REMOVEADDRESS  */
    FETCH_REMOVEADDRESS_FULFILLED,
    FETCH_REMOVEADDRESS_REJECTED,
    FETCH_REMOVEADDRESS_PENDING,
    RESET_REMOVEADDRESS,
  } from "../../actions/payment/removeAddress";
  const initialState = {
    done: false,
    error: false,
    spinner: false,
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_REMOVEADDRESS_PENDING:
        return {
          done: false,
          error: false,
          spinner: true,
        };
      case FETCH_REMOVEADDRESS_FULFILLED:
        return {
          ...state,
          removeAddress: action.payload,
          done: true,
          error: false,
          spinner: false,
        };
      case FETCH_REMOVEADDRESS_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner: false,
        };
      case RESET_REMOVEADDRESS:
        return {
          initialState,
          done: false,
          error: false,
          spinner: false,
        };
      default:
        return state;
    }
  };
  